import ArtsCollections from '../../../assets/categories/ArtsCollectibles.png';
import ArtsCollectionsThumb from '../../../assets/categories/personalized/ArtsCollectibles.png';
import DIY from '../../../assets/categories/DIY.png';
import DIYThumb from '../../../assets/categories/personalized/DIY.png';
import Education from '../../../assets/categories/Education.png';
import EducationThumb from '../../../assets/categories/personalized/Education.png';
import Electronics from '../../../assets/categories/Electronics.png';
import ElectronicsThumb from '../../../assets/categories/personalized/Electronics.png';
import Entertainment from '../../../assets/categories/Entertainment.png';
import EntertainmentThumb from '../../../assets/categories/personalized/Entertainment.png';
import Fashion from '../../../assets/categories/Fashion.png';
import FashionThumb from '../../../assets/categories/personalized/Fashion.png';
import FitnessWellness from '../../../assets/categories/FitnessWellness.png';
import FitnessWellnessThumb from '../../../assets/categories/personalized/FitnessWellness.png';
import FoodBeverages from '../../../assets/categories/FoodBeverages.png';
import FoodBeveragesThumb from '../../../assets/categories/personalized/FoodBeverages.png';
import GamesToys from '../../../assets/categories/GamesToys.png';
import GamesToysThumb from '../../../assets/categories/personalized/GamesToys.png';
import HairBeauty from '../../../assets/categories/HairBeauty.png';
import HairBeautyThumb from '../../../assets/categories/personalized/HairBeauty.png';
import HomeLiving from '../../../assets/categories/HomeLiving.png';
import HomeLivingThumb from '../../../assets/categories/personalized/HomeLiving.png';
import Pets from '../../../assets/categories/Pets.png';
import PetsThumb from '../../../assets/categories/personalized/Pets.png';
import ProfessionalServices from '../../../assets/categories/ProfessionalServices.png';
import ProfessionalServicesThumb from '../../../assets/categories/personalized/ProfessionalServices.png';
import SocialConnections from '../../../assets/categories/SocialConnections.png';
import SocialConnectionsThumb from '../../../assets/categories/personalized/SocialConnections.png';
import Travel from '../../../assets/categories/Travel.png';
import TravelThumb from '../../../assets/categories/personalized/Travel.png';
import Transportation from '../../../assets/categories/Transport.png';
import TransportationThumb from '../../../assets/categories/personalized/Transportation.png';

// College pilot specific images
import AttractMoreCustomers from '../../../assets/categories/collegePilot/AttractMoreCustomers.png';
import BusinessFinance from '../../../assets/categories/collegePilot/BusinessFinance.png';
import CareerGrowth from '../../../assets/categories/collegePilot/CareerGrowth.png';
import DesignCreative from '../../../assets/categories/collegePilot/DesignCreative.png';
import TechSupport from '../../../assets/categories/collegePilot/TechSupport.png';

export const IMAGE_CATEGORIES = [
  {
    label: 'Art & Design',
    value: ['ART_COLLECTIBLES', 'ART', 'BOOKS', 'PAINTING', 'PHOTOGRAPHY'],
    image: ArtsCollections,
    thumbnail: ArtsCollectionsThumb,
  },
  {
    label: 'DIY',
    value: ['DIY'],
    image: DIY,
    thumbnail: DIYThumb,
  },

  {
    label: 'Education',
    value: ['EDUCATION', 'BOOKS'],
    image: Education,
    thumbnail: EducationThumb,
  },
  {
    label: 'Electronics',
    value: ['ELECTRONICS'],
    image: Electronics,
    thumbnail: ElectronicsThumb,
  },
  {
    label: 'Entertainment',
    value: ['ENTERTAINMENT', 'CONCERT'],
    image: Entertainment,
    thumbnail: EntertainmentThumb,
  },
  {
    label: 'Fashion',
    value: ['FASHION', 'CLOTHING'],
    image: Fashion,
    thumbnail: FashionThumb,
  },
  {
    label: 'Fitness & Wellness',
    value: ['FITNESS_WELLNESS', 'WELLNESS', 'FITNESS', 'BIKES', 'SPORTS'],
    image: FitnessWellness,
    thumbnail: FitnessWellnessThumb,
  },
  {
    label: 'Food and beverages',
    value: ['FOOD_BEVERAGES', 'FOOD_SERVICE', 'GROCERIES', 'GROCERY_SERVICE'],
    image: FoodBeverages,
    thumbnail: FoodBeveragesThumb,
  },
  {
    label: 'Games & Toys',
    value: ['GAME_TOYS', 'TOYS'],
    image: GamesToys,
    thumbnail: GamesToysThumb,
  },

  {
    label: 'Hair & Beauty',
    value: [
      'HAIR_BEAUTY',
      'BEAUTY',
      'EYELASHES',
      'HAIR',
      'NAILS',
      'HAIRCUTS',
      'TATTOOS',
    ],
    image: HairBeauty,
    thumbnail: HairBeautyThumb,
  },
  {
    label: 'Home & Living',
    value: [
      'HOME_LIVING',
      'HOME',
      'FURNITURE',
      'CLEANING',
      'ASSEMBLY',
      'DELIVERY',
      'HANDYMAN_SERVICES',
      'HOME',
      'LAUNDRY',
      'MOVING_SERVICE',
    ],
    image: HomeLiving,
    thumbnail: HomeLivingThumb,
  },
  {
    label: 'Professional Services',
    value: [
      'PROFESSIONAL_SERVICES',
      'DATA_ENTRY',
      'EVENT_PLANNING',
      'WEB_DESIGN',
      'PROFESSIONAL_DEVELOPMENT',
      'MENTORSHIP',
    ],
    image: ProfessionalServices,
    thumbnail: ProfessionalServicesThumb,
  },
  {
    label: 'Pets',
    value: ['PETS', 'PET_SERVICE'],
    image: Pets,
    thumbnail: PetsThumb,
  },
  {
    label: 'Social Connections',
    value: ['SOCIAL', 'EVENT_PLANNING'],
    image: SocialConnections,
    thumbnail: SocialConnectionsThumb,
  },
  {
    label: 'Transportation',
    value: ['TRANSPORTATION', 'AUTOMOBILE', 'BIKES', 'RIDES'],
    image: Transportation,
    thumbnail: TransportationThumb,
  },
  {
    label: 'Travel',
    value: ['TRAVEL', 'RIDES'],
    image: Travel,
    thumbnail: TravelThumb,
  },
];

export const PIL0T_IMAGE_CATEGORIES = [
  {
    label: 'Marketing & Sales',
    value: ['Attract More Customers', 'ATTRACT_MORE_CUSTOMERS', 'MARKETING'],
    image: AttractMoreCustomers,
    thumbnail: SocialConnectionsThumb,
    hyperLinks: [
      {
        label: 'Social Media Management',
        assetId: '29559dc2-2571-4d29-a34b-a9f16eadf7e4',
      },
      {
        label: 'Content Creation',
        assetId: 'edbac156-bced-4b5e-95d1-7d0cc0b38767',
      },
      {
        label: 'Influencer Collabs',
        assetId: 'e5ed5b7f-7b03-4b9f-ab64-7f5f4fefb59d',
      },
      { label: 'Marketing', assetId: '909909d6-7cf8-4af5-a18e-f84ddfc342c5' },
    ],
  },
  {
    label: 'Tech Support & Dev',
    value: ['TECH_SUPPORT_DEV'],
    image: TechSupport,
    thumbnail: ElectronicsThumb,
    hyperLinks: [
      {
        label: 'Website & App Development',
        assetId: '6d7a0f90-4538-414c-806d-718d63f7f2b9',
      },
      {
        label: 'Coding Lessons',
        assetId: '5c6ae201-f4a0-4d0a-85da-b5636af03c88',
      },
      { label: 'Code Review', assetId: '2c007e26-2180-49c9-af87-f73907e1fa7b' },
      { label: 'UXUI Design', assetId: 'b438b2d2-ebb1-45e7-acf5-4cb81d103e6b' },
    ],
  },
  {
    label: 'Design & Creative Skills',
    value: ['DESIGN_CREATIVE_SKILL'],
    image: DesignCreative,
    thumbnail: ArtsCollectionsThumb,
    hyperLinks: [
      {
        label: 'Video Editing',
        assetId: '8e2f039a-5549-49c2-b314-91d0ec92d814',
      },
      { label: 'Photography', assetId: 'b1365b31-ac7c-4a26-b509-797cd7d13e3c' },
      {
        label: 'Creative Partners',
        assetId: 'f4db552a-a024-4b9f-923c-6b582ce3fc00',
      },
    ],
  },
  {
    label: 'Career Growth',
    value: ['CAREER_BOOST_MENTORSHIP'],
    image: CareerGrowth,
    thumbnail: EducationThumb,
    hyperLinks: [
      {
        label: 'Career Coaching',
        assetId: 'fae70479-263f-4b56-9eab-2d12b1aad902',
      },
      {
        label: 'Resume Reviews',
        assetId: 'b02d8eda-c5bf-4417-bbd1-834de9b5c123',
      },
      {
        label: 'Interview Prep',
        assetId: 'fae70479-263f-4b56-9eab-2d12b1aad902',
      },
      {
        label: 'Essay Reviews',
        assetId: '351cb924-fb53-4753-837f-1ce832976928',
      },
    ],
  },
  {
    label: 'Business & Finance',
    value: ['BUSINESS_FINANCE'],
    image: BusinessFinance,
    thumbnail: ProfessionalServicesThumb,
    hyperLinks: [
      {
        label: 'Business Incorporation',
        assetId: '6b8a11d8-8572-4515-a0a9-ec90eb7804ea',
      },
      {
        label: 'Fundraising Strategy',
        assetId: '2eeed42f-343c-4cdb-a243-9cd9222518de',
      },
      {
        label: 'Financial Planning',
        assetId: '2972b940-3ae4-4519-bfbe-f577824985bd',
      },
      {
        label: 'Grant Writing',
        assetId: '0c331027-3706-4fff-b415-832a9b57b855',
      },
    ],
  },
  {
    label: 'Lifestyle & Wellbeing',
    value: ['WELLBEING_LIFESTYLE'],
    image: HairBeauty,
    thumbnail: HairBeautyThumb,
    hyperLinks: [
      {
        label: 'Meal Prep / Cooking lessons',
        assetId: '6b14ee6c-ac01-4bf3-a49c-a74dead41a62',
      },
      {
        label: 'Cleaning Services',
        assetId: '7d2cbdd0-1183-4df3-9eea-e32fdca1d548',
      },
      {
        label: 'Fitness Coaching',
        assetId: '9e0e8804-6f4f-45aa-af63-a9dacd075078',
      },
      { label: 'Tattoos', assetId: 'eae4c542-3865-4280-bc59-dd77dbe65293' },
    ],
  },
];
